import useRouter from "@stadium/hooks/lib/use-custom-route";
import { useSelector } from "react-redux";
import Link from "next/link";

import { getMenu } from "@store/selectors/menu";
import { getSelectedMenuItem, getSubcategories } from "@helpers/menu";
import { getIsLockerShop } from "@selectors/store";

import { useStoreContext } from "@components/store/provider";

import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";
import {
  DropdownToggle,
  ResponsiveDrawerDropdown,
  DropdownItem,
} from "@stadium/ui/src/components/bootstrap-dropdown";
import GlobalProductSearch from "@sharedComponents/global-search/global-product-search";
import { ExternalButton } from "@sharedComponents/buttons";

import { getMenuItemRoute } from "@constants/routes";

import styles from "./main.module.scss";

const MobileMenuCategories = () => {
  const router = useRouter();
  const { category, subCategory } = router.query;
  const menu = useSelector(getMenu);
  const { storeBasePath, persistedFiltersQuery } = useStoreContext();
  const isLockerShop = useSelector(getIsLockerShop);

  const parentCategory = getSelectedMenuItem(menu, category) || {
    children: [],
  };

  const menuList = menu.children;
  const subCategories = parentCategory.children;
  const subCategoriesLength = subCategories.length;
  const withSwag = parentCategory.forSwag;

  const modifiedSubCategories = getSubcategories(parentCategory);

  const hideContentForMerch = withSwag && !isLockerShop;

  const parentCategoryLabel = parentCategory.name || "Select Category";

  const renderScrollableCategoriesNav = () =>
    modifiedSubCategories.map(({ code, id, name }) => {
      const currentCategorySelected = code === subCategory;
      const slug = getMenuItemRoute({
        storeBasePath,
        category: code,
      });
      return (
        <div
          className={`${styles.horizontalNavItem} ${currentCategorySelected ? "active" : ""}`}
          key={id}
        >
          <ExternalButton
            href={slug}
            styleType="no-style"
            className={styles.scrollableCategoriesBlockLink}
          >
            {name}
          </ExternalButton>
        </div>
      );
    });

  if (menuList?.length === 0) return null;

  return (
    <div className={styles.scrollableSearchBlock}>
      <BottomIconHideWrapper>
        <ResponsiveDrawerDropdown
          label={
            <DropdownToggle
              showDropdownIcon
              activeClassName={styles.openDDClass}
              className={styles.navItemDropdownBlock}
            >
              <div className={styles.defaultHeading}>{parentCategoryLabel}</div>
            </DropdownToggle>
          }
          heading={<DropdownToggle>{parentCategoryLabel}</DropdownToggle>}
        >
          {menuList.map(({ id, name, code }) => (
            <DropdownItem isActive={code === category} key={id} eventKey={id}>
              <Link
                prefetch={false}
                passHref
                href={getMenuItemRoute({
                  storeBasePath,
                  category: code,
                  query: persistedFiltersQuery,
                })}
                className={styles.horizontalNavItemLink}
              >
                <span className={styles.defaultListItem}>{name}</span>
              </Link>
            </DropdownItem>
          ))}
        </ResponsiveDrawerDropdown>
      </BottomIconHideWrapper>
      {!hideContentForMerch && <GlobalProductSearch />}
      {!(hideContentForMerch || subCategoriesLength === 0) && (
        <div
          className={`${styles.scrollableCategoriesBlock} ${
            hideContentForMerch ? styles.merchCategoryBlock : ""
          }`}
        >
          {renderScrollableCategoriesNav()}
        </div>
      )}
    </div>
  );
};

export default MobileMenuCategories;
